import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {del, insert, set} from 'object-path-immutable'
import GeneralInformation from "./GeneralInformation";
import {useSnackbar} from "notistack";
import getSafe from "../JsonScreen/Utils/getSafeValues";
import request from "../../Services/API/Requests";
import MenuItemsProperties from "./MenuItemsProperties";
import findByString from "../../Utils/Form/FormDynamic/Utils/getValueByString";
import {MenuDesignerContext} from "../../ContextComponents/MenuDesignerContext/MenuDesignerContext";
import BottomMenu from "./BottomMenu/BottomMenu";
import Confirmation from "../../Utils/Confirmation/Confirmation";
import {useHistory, useLocation} from "react-router";
import {successMessage} from "../JsonScreen/Utils";

const useStyles = makeStyles(() => ({
    container: {
        width: 1000
    },
    content: {
        height: '80vh',
        maxHeight: 600,
        overflowY: 'auto'
    }
}));

const menuItem = {
    properties: {
        label: "New Menu Item",
        url: ""
    },
    styles: [{
        fontSize: '',
        color: '',
        background: ''
    }],

};

const contextItem = {
    label: "New Context Item",
    icon: "",
    events: [{event: "onClick", actions: [{}]}]
};

function findAllRefsChildren(arr) {
    let result = [];

    function recurse(items, currentPath, isFromSubRef) {
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const path = currentPath ? `${currentPath}.${i}` : `${i}`;

            if (isFromSubRef) {
                result.push({...item, path});
            }

            if (Array.isArray(item.sub)) {
                recurse(item.sub, path + '.sub', (item.properties.subRef || isFromSubRef));
            }
        }
    }

    recurse(arr, '');
    return result;
}

const MenuDesigner = (props) => {
    const {
        match: {params: {id}}, isPopup, isContextEditor,
        closePopup, returnValue, inParam
    } = props;
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const {enqueueSnackbar} = useSnackbar();

    const [activeTab, setActiveTab] = useState(0);
    const [values, setValues] = useState({main: []});
    const [withRefs, setWithRefs] = useState([]);
    const [selectedItem, setSelectedItem] = useState({path: "", item: {}, isDisabled: false});
    const [isUpdate, setIsUpdate] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (inParam.defaultValues) {
            setValues(inParam.defaultValues)
        }
    }, []);

    useEffect(() => {
        async function getMenuData() {
            try {
                const response = await request({
                    url: "menu/read",
                    data: {id}
                });
                setValues(response)
                const refs = findAllRefsChildren(response.main)
                setWithRefs(refs.map(v => v.path))
            } catch (e) {
                let message = getSafe(() => e.data.status.message[0].text, 'Error');
                enqueueSnackbar(message, {variant: 'error'});
            }
        }

        id && getMenuData();
        setIsUpdate(Boolean(id))
    }, [id]);

    function selectItem(path, inItem) {
        const res = withRefs.find(v => {
            return v === path
        })
        const item = inItem ? inItem : findByString(values.main, path);
        setSelectedItem({item, path, isDisabled: Boolean(res)});
    }

    function onChangeValues(value, path) {
        const newValues = set(values, path, value);
        setValues(newValues)
    }

    async function onChangeMenuItemProps(value, path) {
        let newSelectedItem = selectedItem.item;
        const property = path.split('.')[path.split('.').length - 1];
        const pathToObject = path.split('.').slice(0, path.split('.').length - 2).join('.');
        let newValues;

        if (property === 'subRef') {
            let newItemSelected = {
                ...newSelectedItem,
                properties: {...newSelectedItem.properties, subRef: value || undefined},
                sub: undefined
            }
            //read menu and insert in sub
            if (value) {
                try {
                    const subMenuRef = await request({
                        url: "menu/read",
                        data: {
                            id: value
                        }
                    });
                    newItemSelected.properties.subRef = value;
                    newItemSelected.sub = subMenuRef.main;
                } catch (e) {
                    console.log('get sub ref error', e);
                }
            }


            newValues = set(values, `main.${pathToObject}`, newItemSelected);
            newSelectedItem = newItemSelected
        } else {
            newValues = set(values, `main.${path}`, value ? value : undefined);
        }

        setSelectedItem(prevProps => {
            return {
                ...prevProps,
                item: newSelectedItem
            }
        });
        setValues(newValues)
    }

    function saveAction(value, path) {
        const newSelectedItem = set(selectedItem.item, path, value);
        const newValues = set(values, `main.${selectedItem.path}.${path}`, value);
        setSelectedItem(prevProps => {
            return {
                ...prevProps,
                item: newSelectedItem
            }
        });
        setValues(newValues)
    }

    function removeEvent(path, eventIndex) {
        const itemEvents = findByString(values, `main.${path}.events`) || [];

        if (itemEvents.length <= 1) {
            setValues(set(values, `main.${path}.events.0`, {}))
            setSelectedItem(prevProps => {
                return {
                    ...prevProps,
                    item: set(selectedItem.item, `events.0`, {})
                }
            });
            return
        }

        const newSelectedItem = del(selectedItem.item, `events.${path}`);
        const newValues = del(values, `main.${path}.events.${eventIndex}`);
        setSelectedItem(prevProps => {
            return {
                ...prevProps,
                item: newSelectedItem
            }
        });
        setValues(newValues)
    }

    function createEvent(index) {
        const emptyEvent = {event: "", actions: [{param: [{}]}]};
        const newSelectedItem = set(selectedItem.item, `events.${index}`, emptyEvent);
        const newValues = set(values, `main.${selectedItem.path}.events.${index}`, emptyEvent)
        setSelectedItem(prevProps => {
            return {
                ...prevProps,
                item: newSelectedItem
            }
        });
        setValues(newValues)
    }


    function onChangePosition(itemPath, parentPath, currentIndex, newIndex) {
        const currentParent = findByString(values.main, parentPath);
        const currentItem = findByString(values.main, itemPath);

        //return when first item and direction up, last item and direction down
        if (newIndex + 1 > currentParent.length || newIndex + 1 <= 0) return;

        //move down
        if (currentIndex < newIndex) {
            let removeOld = del(values.main, itemPath);
            let ins = insert(removeOld, parentPath, currentItem, newIndex);
            setValues(prevState => {
                return {
                    ...prevState,
                    main: ins
                }
            });
            selectItem(`${parentPath}.${newIndex}`, currentItem)
        }
        //move up
        if (currentIndex > newIndex) {
            let removeOld = del(values.main, itemPath);
            let ins = insert(removeOld, parentPath, currentItem, newIndex);
            setValues(prevState => {
                return {
                    ...prevState,
                    main: ins
                }
            });
            selectItem(`${parentPath}.${newIndex}`, currentItem)
        }
    }

    function onChangeIndent(itemPath, direction, currentIndex) {
        const currentItem = findByString(values.main, itemPath);
        let splitPath = itemPath.split('.');

        if (direction === 'up' && currentIndex > 0) {
            splitPath[splitPath.length - 1] = splitPath[splitPath.length - 1] - 1;
            const destinationPath = `${splitPath.join('.')}.sub`;
            const destinationArray = findByString(values.main, destinationPath);
            const destinationIndex = destinationArray ? destinationArray.length : 0;
            const insertCurrent = insert(values.main, destinationPath, currentItem, destinationIndex);
            const deleteCurrent = del(insertCurrent, itemPath);
            setValues(prevState => {
                return {
                    ...prevState,
                    main: deleteCurrent
                }
            });
            selectItem(`${destinationPath}.${destinationIndex}`, currentItem)
        }

        if (direction === 'down' && splitPath.length > 1) {
            const destinationPath = splitPath.slice(0, splitPath.length - 3).join('.');
            const destinationPosition = splitPath.slice(0, splitPath.length - 2);
            const destinationIndex = Number(destinationPosition[destinationPosition.length - 1]) + 1;
            const insertCurrent = insert(values.main, destinationPath, currentItem, destinationIndex);
            const deleteCurrent = del(insertCurrent, itemPath);
            setValues(prevState => {
                return {
                    ...prevState,
                    main: deleteCurrent
                }
            });
            selectItem(`${destinationPath}.${destinationIndex}`, currentItem)
        }
    }

    function onCreateItem(path, index) {
        const isFirstLevel = `${path}`.split('.').length <= 1;
        const newItem = isContextEditor ? contextItem : menuItem;
        const newValues = insert(values.main, isFirstLevel ? '' : path, newItem, index);
        setValues(prevProps => {
            return {
                ...prevProps,
                main: newValues
            }
        });
        selectItem(`${path}.${index}`, menuItem);
    }

    function onRemoveItem(path) {
        //TODO if has children, show confirmation for deleting
        let newValues = del(values.main, path);
        setValues(prevProps => {
            return {
                ...prevProps,
                main: newValues
            }
        })
    }

    async function onDelete() {
        try {
            await request({
                url: '/menu/delete',
                method: 'POST',
                data: {id}
            });
            enqueueSnackbar('Success', {variant: 'success'});
            history.goBack();
        } catch (e) {

        }
    }

    async function onSave() {
        try {
            setLoading(true);
            const response = await request({
                url: `/menu/update`,
                data: values
            });
            setLoading(false);
            if (isContextEditor) {
                returnValue(response.id);
                isPopup && closePopup();
                return
            }

            if (!isPopup) {
                enqueueSnackbar(successMessage(
                        response.id, history, location.pathname, location.state.prevState),
                    {variant: `success`}
                );
                history.goBack();
                return
            }

            returnValue({}, response.id);
            closePopup();
        } catch (e) {

        }
    }

    function onCancel() {
        isPopup ? closePopup() : history.goBack()
    }

    return (
        <MenuDesignerContext.Provider value={{
            values,
            onChangeValues,
            menu: values.main,
            selectItem,
            selectedItem,
            onChangeMenuItemProps,
            saveAction,
            onChangePosition,
            onCreateItem,
            onChangeIndent,
            onRemoveItem,
            removeEvent,
            createEvent,
            onOpenConfirmation: () => setConfirmation(true),
            onSave,
            isUpdate,
            onCancel,
            isContextEditor
        }}>
            <div className={classes.container} style={{margin: isPopup ? '0px' : '10px auto'}}>
                <div
                    className={classes.content}
                    style={{padding: isPopup ? 0 : 10}}
                >
                    <Paper square>
                        <Tabs onChange={(e, v) => setActiveTab(v)} value={activeTab} indicatorColor="primary">
                            <Tab label={'General Information'}/>
                            <Tab label={isContextEditor ? 'Context Items' : 'Menu Items'}/>
                        </Tabs>
                    </Paper>
                    <div style={{height: 'calc(100% - 106px)'}}>
                        <Paper square style={{marginTop: 5, height: '100%'}}>
                            {activeTab === 0 && (
                                <GeneralInformation/>
                            )}
                            {activeTab === 1 && (
                                <MenuItemsProperties/>
                            )}
                        </Paper>
                        <BottomMenu/>
                    </div>
                    <Confirmation
                        open={confirmation}
                        close={() => setConfirmation(false)}
                        submit={onDelete}
                    />
                </div>

            </div>
        </MenuDesignerContext.Provider>
    )
};

export default MenuDesigner

MenuDesigner.propTypes = {
    match: PropTypes.object,
    isPopup: PropTypes.bool,
    isContextEditor: PropTypes.bool,
    returnValue: PropTypes.func,
    closePopup: PropTypes.func,
    inParam: PropTypes.shape({
        defaultValues: PropTypes.object
    })
};

MenuDesigner.defaultProps = {
    inParam: {}
};
